import ImportExportBar from "../../finance/shared/ImportExportBar";
import { Link } from "react-router-dom";
import { useState, useEffect, useCallback, useRef } from "react";
import apiFetch from "../../../shared/services/apiClient";
import styles from "../components/Tables/ListResidents.module.css";
import stepsStyles from "../components/Stepper/Steps/steps.module.css";
import { FieldError, ForeignToggle } from "../components/FieldHelpers";
import { useCedulaLookup } from "../services/useCedulaLookup";
import { formatPhone } from "../services/formatPhone";


import {
  validateFilial,
  validatePropietario,
  validateCopropietario,
  validateAutorizado,
  REGEX_PLANO,
  REGEX_FOLIO,
} from "../services/validationRules";
// ── Imperative toast (funciona en cualquier componente sin hook) ──────────────
function showToast(msg, ok = true) {
  const existing = document.getElementById('__condo_toast__');
  if (existing) existing.remove();
  const el = document.createElement('div');
  el.id = '__condo_toast__';
  el.style.cssText = [
    'position:fixed','bottom:24px','right:24px','z-index:9999',
    'padding:12px 20px','border-radius:10px','font-size:0.88rem',
    'font-weight:600','max-width:400px','word-break:break-word',
    'box-shadow:0 8px 32px rgba(0,0,0,0.45)',
    ok
      ? 'background:rgba(34,197,94,0.15);border:1px solid rgba(34,197,94,0.4);color:#86efac'
      : 'background:rgba(239,68,68,0.15);border:1px solid rgba(239,68,68,0.4);color:#fca5a5',
  ].join(';');
  el.textContent = msg;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 5000);
}

// ── Shared modal styles ───────────────────────────────────────────────────────
const OVERLAY = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.65)",
  backdropFilter: "blur(3px)",
  zIndex: 1000,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
const MODAL_BOX = {
  background: "var(--bg-card)",
  border: "1px solid var(--border-card)",
  borderRadius: 12,
  padding: 24,
  zIndex: 1001,
  boxShadow: "0 24px 64px rgba(0,0,0,0.55)",
  width: "min(560px,94vw)",
  maxHeight: "90vh",
  overflowY: "auto",
};

// ── Confirm delete modal ──────────────────────────────────────────────────────
function ConfirmModal({ open, name, onConfirm, onCancel, loading }) {
  if (!open) return null;
  return (
    <div style={OVERLAY} onClick={onCancel}>
      <div
        style={{ ...MODAL_BOX, width: "min(400px,90vw)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <div style={{ fontSize: "2.5rem", marginBottom: 8 }}>🗑️</div>
          <h3 style={{ color: "#f1f5f9", margin: 0 }}>¿Eliminar registro?</h3>
          <p style={{ color: "var(--text-secondary)", marginTop: 6, fontSize: "0.88rem" }}>
            Se eliminará <strong style={{ color: "#f87171" }}>{name}</strong>{" "}
            permanentemente. Esta acción no se puede deshacer.
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
          <button
            type="button"
            onClick={onCancel}
            style={{
              padding: "8px 20px",
              background: "rgba(55,65,81,0.4)",
              border: "1px solid var(--border-card)",
              borderRadius: 7,
              color: "var(--text-secondary)",
              cursor: "pointer",
              fontSize: "0.84rem",
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            style={{
              padding: "8px 20px",
              background: "rgba(239,68,68,0.15)",
              border: "1px solid rgba(239,68,68,0.4)",
              borderRadius: 7,
              color: "#f87171",
              cursor: "pointer",
              fontSize: "0.84rem",
              fontWeight: 600,
            }}
          >
            {loading ? "Eliminando…" : "Sí, eliminar"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Generic field row ─────────────────────────────────────────────────────────
function Field({ label, required, children, error }) {
  return (
    <div className="form-group mb-2">
      <label
        className="form-label"
        style={{ fontSize: "0.83rem", color: "var(--text-secondary)" }}
      >
        {label}
        {required && <span style={{ color: "#f87171" }}> *</span>}
      </label>
      {children}
      <FieldError msg={error} />
    </div>
  );
}

function Inp({ value, onChange, onBlur, placeholder, style, maxLength }) {
  return (
    <input
      type="text"
      className={`${stepsStyles["form-control"]} form-control`}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      style={style}
      maxLength={maxLength}
    />
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// EDIT FILIAL MODAL
// ═══════════════════════════════════════════════════════════════════════════════
function EditFilialModal({ filial, onClose, onSaved }) {
  const [form, setForm] = useState({
    idFilial: filial.idFilial || "",
    numPlano: filial.numPlano || "",
    numFolio: filial.numFolio || "",
    tipoPropiedad: filial.tipo_propiedad || "",
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  function handlePlano(e) {
    let raw = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    let fmt = raw;
    if (raw.length > 1) fmt = raw[0] + "-" + raw.slice(1);
    if (raw.length > 6)
      fmt = raw[0] + "-" + raw.slice(1, 6) + "-" + raw.slice(6);
    setForm((p) => ({ ...p, numPlano: fmt.slice(0, 12) }));
  }
  function handleFolio(e) {
    const d = e.target.value.replace(/[^0-9]/g, "").slice(0, 9);
    let out =
      d.length === 0
        ? ""
        : d.length === 1
          ? d
          : d.length <= 6
            ? d[0] + "-" + d.slice(1)
            : d[0] + "-" + d.slice(1, 6) + "-F-" + d.slice(6);
    setForm((p) => ({ ...p, numFolio: out }));
  }

  async function handleSave(e) {
    e.preventDefault();
    e.stopPropagation();
    // Adapt form keys to match validateFilial interface
    const errs = validateFilial({ ...form });
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setSaving(true);
    try {
      const res = await apiFetch(`/api/residents/filial/${filial.id}/`, {
        method: "PATCH",
        body: JSON.stringify({
          idFilial: form.idFilial,
          numPlano: form.numPlano,
          numFolio: form.numFolio,
          tipo_propiedad: form.tipoPropiedad,
        }),
      });
      if (!res.ok) {
        const e = await res.json();
        throw new Error(JSON.stringify(e));
      }
      onSaved();
    } catch (e) {
      showToast("Error al guardar: " + e.message, false);
    } finally {
      setSaving(false);
    }
  }

  const planoOk = REGEX_PLANO.test(form.numPlano.trim());
  const folioOk = REGEX_FOLIO.test(form.numFolio.trim());

  return (
    <div style={OVERLAY} onClick={onClose}>
      <div style={MODAL_BOX} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ color: "#f1f5f9", margin: "0 0 16px" }}>
          <i
            className="fa-solid fa-pen-to-square"
            style={{ color: "#f97316", marginRight: 8 }}
          />
          Editar Filial — {filial.idFilial}
        </h3>
        <Field label="ID Filial" required error={errors.idFilial}>
          <Inp
            value={form.idFilial}
            placeholder="A01"
            style={{ borderColor: errors.idFilial ? "#ef4444" : undefined }}
            onChange={(e) =>
              setForm((p) => ({ ...p, idFilial: e.target.value }))
            }
          />
        </Field>
        <div className="row g-3 mb-2">
          <div className="col-12 col-md-6">
            <Field label="Número Plano" required error={errors.numPlano}>
              <Inp
                value={form.numPlano}
                placeholder="A-00000-2020"
                maxLength={12}
                style={{
                  borderColor: errors.numPlano
                    ? "#ef4444"
                    : planoOk
                      ? "#4ade80"
                      : undefined,
                }}
                onChange={handlePlano}
              />
            </Field>
          </div>
          <div className="col-12 col-md-6">
            <Field label="Número Folio" required error={errors.numFolio}>
              <Inp
                value={form.numFolio}
                placeholder="1-10101-F-000"
                maxLength={13}
                style={{
                  borderColor: errors.numFolio
                    ? "#ef4444"
                    : folioOk
                      ? "#4ade80"
                      : undefined,
                }}
                onChange={handleFolio}
              />
            </Field>
          </div>
        </div>
        <Field label="Tipo de Propiedad" required error={errors.tipoPropiedad}>
          <select
            className={`${stepsStyles["form-select"]} form-select ${stepsStyles["form-control"]} form-control`}
            value={form.tipoPropiedad}
            style={{
              borderColor: errors.tipoPropiedad ? "#ef4444" : undefined,
            }}
            onChange={(e) =>
              setForm((p) => ({ ...p, tipoPropiedad: e.target.value }))
            }
          >
            <option value="">— Seleccioná el tipo —</option>
            <option value="Construida">Construida</option>
            <option value="Lote Vacio">Lote vacío</option>
            <option value="En Construccion">En construcción</option>
          </select>
        </Field>
        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button
            type="button"
            onClick={handleSave}
            disabled={saving}
            style={{
              padding: "8px 20px",
              background: "#f97316",
              border: "none",
              borderRadius: 7,
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: "0.84rem",
            }}
          >
            {saving ? "Guardando…" : "Guardar cambios"}
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "rgba(55,65,81,0.4)",
              border: "1px solid var(--border-card)",
              borderRadius: 7,
              color: "var(--text-secondary)",
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// EDIT PROPIETARIO MODAL
// ═══════════════════════════════════════════════════════════════════════════════
function EditOwnerModal({ owner, onClose, onSaved }) {
  const [form, setForm] = useState({
    cedula: owner.propietario?.persona?.cedula || "",
    nombre: owner.propietario?.persona?.nombre || "",
    apellidos: owner.propietario?.persona?.apellidos || "",
    nombre_sociedad: owner.propietario?.persona?.nombre_sociedad || "",
    telefono_casa: owner.propietario?.telefono_casa || "",
    telefono_cel: owner.propietario?.telefono_cel || "",
    telefono_trabajo: owner.propietario?.telefono_trabajo || "",
    placaVehiculo: owner.propietario?.placa_vehiculo || "",
    placaExtranjera: false,
    notas: owner.propietario?.notas || "",
    emailPrincipal: owner.email || "",
    emailExtras: [],
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const { buscar, resultado, estado } = useCedulaLookup();

  useEffect(() => {
    if (resultado) {
      setForm((p) => ({
        ...p,
        nombre: resultado.nombre || p.nombre,
        apellidos: resultado.apellidos || p.apellidos,
      }));
    }
  }, [resultado]);

  function set(field, value) {
    setForm((p) => ({ ...p, [field]: value }));
  }
  function toggle(field) {
    setForm((p) => ({ ...p, [field]: !p[field] }));
  }

  async function handleSave(e) {
    e.preventDefault();
    e.stopPropagation();
    const errs = validatePropietario(form);
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setSaving(true);
    try {
      // 1. PATCH Persona (cedula, nombre, apellidos)
      const personaId = owner.propietario?.persona?.id;
      if (personaId) {
        await apiFetch(`/api/residents/persona/${personaId}/`, {
          method: "PATCH",
          body: JSON.stringify({
            cedula: form.cedula,
            nombre: form.nombre,
            apellidos: form.apellidos,
            nombre_sociedad: form.nombre_sociedad || "",
          }),
        });
      }
      // 2. PATCH Propietario (telefono, placa)
      const propId = owner.propietario?.id;
      if (propId) {
        await apiFetch(`/api/residents/propietario/${propId}/`, {
          method: "PATCH",
          body: JSON.stringify({
            telefono_casa:    form.telefono_casa    || null,
            telefono_cel:     form.telefono_cel     || null,
            telefono_trabajo: form.telefono_trabajo || null,
            placa_vehiculo:   form.placaVehiculo    || null,
            notas:            form.notas            || "",
          }),
        });
      }
      // 3. PATCH Email principal
      await apiFetch(`/api/residents/emailPropietario/${owner.id}/`, {
        method: "PATCH",
        body: JSON.stringify({ email: form.emailPrincipal }),
      });
      onSaved();
    } catch (e) {
      showToast("Error al guardar: " + e.message, false);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={OVERLAY} onClick={onClose}>
      <div style={MODAL_BOX} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ color: "#f1f5f9", margin: "0 0 16px" }}>
          <i
            className="fa-solid fa-pen-to-square"
            style={{ color: "#f97316", marginRight: 8 }}
          />
          Editar Propietario
        </h3>

        {/* Cédula + lookup */}
        <Field label="Cédula" required error={errors.cedula}>
          <div style={{ display: "flex", gap: 6 }}>
            <input
              type="text"
              className={`${stepsStyles["form-control"]} form-control`}
              value={form.cedula}
              placeholder="123456789"
              style={{ borderColor: errors.cedula ? "#ef4444" : undefined }}
              onChange={(e) => set("cedula", e.target.value)}
              onBlur={(e) => buscar(e.target.value)}
            />
            <button
              type="button"
              onClick={() => buscar(form.cedula)}
              disabled={estado === "buscando"}
              style={{
                padding: "0 10px",
                background: "rgba(249,115,22,0.15)",
                border: "1px solid rgba(249,115,22,0.4)",
                borderRadius: 6,
                color: "#f97316",
                cursor: "pointer",
              }}
            >
              {estado === "buscando" ? (
                <i className="fa-solid fa-circle-notch fa-spin" />
              ) : (
                <i className="fa-solid fa-magnifying-glass" />
              )}
            </button>
          </div>
        </Field>

        <div className="row g-3 mb-1">
          <div className="col-12 col-md-6">
            <Field label="Nombre" required error={errors.nombre}>
              <Inp
                value={form.nombre}
                placeholder="Nombre"
                style={{ borderColor: errors.nombre ? "#ef4444" : undefined }}
                onChange={(e) => set("nombre", e.target.value)}
              />
            </Field>
          </div>
          <div className="col-12 col-md-6">
            <Field label="Apellidos" required error={errors.apellidos}>
              <Inp
                value={form.apellidos}
                placeholder="Apellidos"
                style={{
                  borderColor: errors.apellidos ? "#ef4444" : undefined,
                }}
                onChange={(e) => set("apellidos", e.target.value)}
              />
            </Field>
          </div>
        </div>

        {/* Nombre Sociedad */}
        <div className="row g-3 mb-1">
          <div className="col-12">
            <Field label="Nombre de Sociedad">
              <Inp
                value={form.nombre_sociedad || ""}
                placeholder="Ej: Inversiones Sol S.A. (dejar vacío si es persona física)"
                onChange={(e) => set("nombre_sociedad", e.target.value)}
              />
            </Field>
          </div>
        </div>

        {/* Teléfonos */}
        <div className="row g-3 mb-1">
          <div className="col-12 col-md-4">
            <Field label="Tel. Casa">
              <Inp value={form.telefono_casa || ""} placeholder="2222-1234"
                onChange={(e) => set("telefono_casa", e.target.value)}/>
            </Field>
          </div>
          <div className="col-12 col-md-4">
            <Field label="Celular">
              <Inp value={form.telefono_cel || ""} placeholder="8888-1234"
                onChange={(e) => set("telefono_cel", e.target.value)}/>
            </Field>
          </div>
          <div className="col-12 col-md-4">
            <Field label="Tel. Trabajo">
              <Inp value={form.telefono_trabajo || ""} placeholder="2200-1234"
                onChange={(e) => set("telefono_trabajo", e.target.value)}/>
            </Field>
          </div>
        </div>

        <div className="row g-3 mb-1">
          <div className="col-12 col-md-6">
            <Field label="Placa de vehículo" error={errors.placaVehiculo}>
              <Inp
                value={form.placaVehiculo}
                placeholder={form.placaExtranjera ? "Placa extranjera" : "ABC-123"}
                style={{ borderColor: errors.placaVehiculo ? "#ef4444" : undefined }}
                onChange={(e) => set("placaVehiculo", e.target.value)}
              />
              <ForeignToggle
                checked={form.placaExtranjera}
                onChange={() => toggle("placaExtranjera")}
                label="Placa extranjera"
              />
            </Field>
          </div>
        </div>

        <Field label="Email principal" required error={errors.emailPrincipal}>
          <Inp
            value={form.emailPrincipal}
            placeholder="email@ejemplo.com"
            style={{
              borderColor: errors.emailPrincipal ? "#ef4444" : undefined,
            }}
            onChange={(e) => set("emailPrincipal", e.target.value)}
          />
        </Field>

        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button
            type="button"
            onClick={handleSave}
            disabled={saving}
            style={{
              padding: "8px 20px",
              background: "#f97316",
              border: "none",
              borderRadius: 7,
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: "0.84rem",
            }}
          >
            {saving ? "Guardando…" : "Guardar cambios"}
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "rgba(55,65,81,0.4)",
              border: "1px solid var(--border-card)",
              borderRadius: 7,
              color: "var(--text-secondary)",
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// EDIT COPROPIETARIO MODAL
// ═══════════════════════════════════════════════════════════════════════════════
function EditCoOwnerModal({ record, onClose, onSaved }) {
  const [form, setForm] = useState({
    cedula: record.persona?.cedula || "",
    nombre: record.persona?.nombre || "",
    apellidos: record.persona?.apellidos || "",
    telefono: record.telefono || "",
    telefonoExtranjero: false,
    placaVehiculo: record.placa_vehiculo || "",
    placaExtranjera: false,
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const { buscar, resultado, estado } = useCedulaLookup();

  useEffect(() => {
    if (resultado)
      setForm((p) => ({
        ...p,
        nombre: resultado.nombre || p.nombre,
        apellidos: resultado.apellidos || p.apellidos,
      }));
  }, [resultado]);

  function set(f, v) {
    setForm((p) => ({ ...p, [f]: v }));
  }
  function toggle(f) {
    setForm((p) => ({ ...p, [f]: !p[f] }));
  }

  async function handleSave(e) {
    e.preventDefault();
    e.stopPropagation();
    const errs = validateCopropietario(form);
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setSaving(true);
    try {
      const personaId = record.persona?.id;
      if (personaId) {
        await apiFetch(`/api/residents/persona/${personaId}/`, {
          method: "PATCH",
          body: JSON.stringify({
            cedula: form.cedula,
            nombre: form.nombre,
            apellidos: form.apellidos,
            nombre_sociedad: form.nombre_sociedad || "",
          }),
        });
      }
      await apiFetch(`/api/residents/copropietario/${record.id}/`, {
        method: "PATCH",
        body: JSON.stringify({
          telefono: form.telefono,
          placa_vehiculo: form.placaVehiculo,
        }),
      });
      onSaved();
    } catch (e) {
      showToast("Error: " + e.message, false);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={OVERLAY} onClick={onClose}>
      <div style={MODAL_BOX} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ color: "#f1f5f9", margin: "0 0 16px" }}>
          <i
            className="fa-solid fa-pen-to-square"
            style={{ color: "#f97316", marginRight: 8 }}
          />
          Editar Copropietario
        </h3>
        <Field label="Cédula" required error={errors.cedula}>
          <div style={{ display: "flex", gap: 6 }}>
            <Inp
              value={form.cedula}
              placeholder="123456789"
              style={{ borderColor: errors.cedula ? "#ef4444" : undefined }}
              onChange={(e) => set("cedula", e.target.value)}
              onBlur={() => buscar(form.cedula)}
            />
            <button
              type="button"
              onClick={() => buscar(form.cedula)}
              disabled={estado === "buscando"}
              style={{
                padding: "0 10px",
                background: "rgba(249,115,22,0.15)",
                border: "1px solid rgba(249,115,22,0.4)",
                borderRadius: 6,
                color: "#f97316",
                cursor: "pointer",
              }}
            >
              {estado === "buscando" ? (
                <i className="fa-solid fa-circle-notch fa-spin" />
              ) : (
                <i className="fa-solid fa-magnifying-glass" />
              )}
            </button>
          </div>
        </Field>
        <div className="row g-3 mb-1">
          <div className="col-12 col-md-6">
            <Field label="Nombre" required error={errors.nombre}>
              <Inp
                value={form.nombre}
                placeholder="Nombre"
                style={{ borderColor: errors.nombre ? "#ef4444" : undefined }}
                onChange={(e) => set("nombre", e.target.value)}
              />
            </Field>
          </div>
          <div className="col-12 col-md-6">
            <Field label="Apellidos" required error={errors.apellidos}>
              <Inp
                value={form.apellidos}
                placeholder="Apellidos"
                style={{
                  borderColor: errors.apellidos ? "#ef4444" : undefined,
                }}
                onChange={(e) => set("apellidos", e.target.value)}
              />
            </Field>
          </div>
        </div>
        <div className="row g-3 mb-1">
          <div className="col-12 col-md-6">
            <Field label="Teléfono" required error={errors.telefono}>
              <Inp
                value={form.telefono}
                placeholder={
                  form.telefonoExtranjero ? "Extranjero" : "8888-1234"
                }
                style={{ borderColor: errors.telefono ? "#ef4444" : undefined }}
                onChange={(e) => set("telefono", e.target.value)}
                onBlur={(e) => {
                  if (!form.telefonoExtranjero)
                    set("telefono", formatPhone(e.target.value));
                }}
              />
              <ForeignToggle
                checked={form.telefonoExtranjero}
                onChange={() => toggle("telefonoExtranjero")}
                label="Número extranjero"
              />
            </Field>
          </div>
          <div className="col-12 col-md-6">
            <Field label="Placa" required error={errors.placaVehiculo}>
              <Inp
                value={form.placaVehiculo}
                placeholder={form.placaExtranjera ? "Extranjera" : "ABC-123"}
                style={{
                  borderColor: errors.placaVehiculo ? "#ef4444" : undefined,
                }}
                onChange={(e) => set("placaVehiculo", e.target.value)}
              />
              <ForeignToggle
                checked={form.placaExtranjera}
                onChange={() => toggle("placaExtranjera")}
                label="Placa extranjera"
              />
            </Field>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button
            type="button"
            onClick={handleSave}
            disabled={saving}
            style={{
              padding: "8px 20px",
              background: "#f97316",
              border: "none",
              borderRadius: 7,
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {saving ? "Guardando…" : "Guardar cambios"}
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "rgba(55,65,81,0.4)",
              border: "1px solid var(--border-card)",
              borderRadius: 7,
              color: "var(--text-secondary)",
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// EDIT AUTORIZADO MODAL
// ═══════════════════════════════════════════════════════════════════════════════
function EditAuthModal({ record, onClose, onSaved }) {
  const [form, setForm] = useState({
    cedula: record.persona?.cedula || "",
    nombre: record.persona?.nombre || "",
    apellidos: record.persona?.apellidos || "",
    placaVehiculo: record.placa_vehiculo || "",
    placaExtranjera: false,
    relacion: record.tipo || "Familiar",
  });
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const { buscar, resultado, estado } = useCedulaLookup();

  useEffect(() => {
    if (resultado)
      setForm((p) => ({
        ...p,
        nombre: resultado.nombre || p.nombre,
        apellidos: resultado.apellidos || p.apellidos,
      }));
  }, [resultado]);

  function set(f, v) {
    setForm((p) => ({ ...p, [f]: v }));
  }
  function toggle(f) {
    setForm((p) => ({ ...p, [f]: !p[f] }));
  }

  async function handleSave(e) {
    e.preventDefault();
    e.stopPropagation();
    const errs = validateAutorizado(form);
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }
    setSaving(true);
    try {
      const personaId = record.persona?.id;
      if (personaId) {
        await apiFetch(`/api/residents/persona/${personaId}/`, {
          method: "PATCH",
          body: JSON.stringify({
            cedula: form.cedula,
            nombre: form.nombre,
            apellidos: form.apellidos,
            nombre_sociedad: form.nombre_sociedad || "",
          }),
        });
      }
      await apiFetch(`/api/residents/autorizado/${record.id}/`, {
        method: "PATCH",
        body: JSON.stringify({
          tipo: form.relacion,
          placa_vehiculo: form.placaVehiculo,
        }),
      });
      onSaved();
    } catch (e) {
      showToast("Error: " + e.message, false);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={OVERLAY} onClick={onClose}>
      <div style={MODAL_BOX} onClick={(e) => e.stopPropagation()}>
        <h3 style={{ color: "#f1f5f9", margin: "0 0 16px" }}>
          <i
            className="fa-solid fa-pen-to-square"
            style={{ color: "#f97316", marginRight: 8 }}
          />
          Editar Autorizado
        </h3>
        <Field label="Cédula" required error={errors.cedula}>
          <div style={{ display: "flex", gap: 6 }}>
            <Inp
              value={form.cedula}
              placeholder="123456789"
              style={{ borderColor: errors.cedula ? "#ef4444" : undefined }}
              onChange={(e) => set("cedula", e.target.value)}
              onBlur={() => buscar(form.cedula)}
            />
            <button
              type="button"
              onClick={() => buscar(form.cedula)}
              disabled={estado === "buscando"}
              style={{
                padding: "0 10px",
                background: "rgba(249,115,22,0.15)",
                border: "1px solid rgba(249,115,22,0.4)",
                borderRadius: 6,
                color: "#f97316",
                cursor: "pointer",
              }}
            >
              {estado === "buscando" ? (
                <i className="fa-solid fa-circle-notch fa-spin" />
              ) : (
                <i className="fa-solid fa-magnifying-glass" />
              )}
            </button>
          </div>
        </Field>
        <div className="row g-3 mb-1">
          <div className="col-12 col-md-6">
            <Field label="Nombre" required error={errors.nombre}>
              <Inp
                value={form.nombre}
                placeholder="Nombre"
                style={{ borderColor: errors.nombre ? "#ef4444" : undefined }}
                onChange={(e) => set("nombre", e.target.value)}
              />
            </Field>
          </div>
          <div className="col-12 col-md-6">
            <Field label="Apellidos" required error={errors.apellidos}>
              <Inp
                value={form.apellidos}
                placeholder="Apellidos"
                style={{
                  borderColor: errors.apellidos ? "#ef4444" : undefined,
                }}
                onChange={(e) => set("apellidos", e.target.value)}
              />
            </Field>
          </div>
        </div>
        <div className="row g-3 mb-1">
          <div className="col-12 col-md-6">
            <Field label="Relación" error={errors.relacion}>
              <select
                className={`${stepsStyles["form-select"]} form-select ${stepsStyles["form-control"]} form-control`}
                value={form.relacion}
                onChange={(e) => set("relacion", e.target.value)}
              >
                <option value="Familiar">Familiar</option>
                <option value="Inquilino">Inquilino</option>
                <option value="Empleado">Empleado</option>
              </select>
            </Field>
          </div>
          <div className="col-12 col-md-6">
            <Field label="Placa" required error={errors.placaVehiculo}>
              <Inp
                value={form.placaVehiculo}
                placeholder={form.placaExtranjera ? "Extranjera" : "ABC-123"}
                style={{
                  borderColor: errors.placaVehiculo ? "#ef4444" : undefined,
                }}
                onChange={(e) => set("placaVehiculo", e.target.value)}
              />
              <ForeignToggle
                checked={form.placaExtranjera}
                onChange={() => toggle("placaExtranjera")}
                label="Placa extranjera"
              />
            </Field>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
          <button
            type="button"
            onClick={handleSave}
            disabled={saving}
            style={{
              padding: "8px 20px",
              background: "#f97316",
              border: "none",
              borderRadius: 7,
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            {saving ? "Guardando…" : "Guardar cambios"}
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "rgba(55,65,81,0.4)",
              border: "1px solid var(--border-card)",
              borderRadius: 7,
              color: "var(--text-secondary)",
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// TABLE COMPONENTS (Owners, CoOwners, Authorized, Filiales)
// ═══════════════════════════════════════════════════════════════════════════════

function ActionButtons({ onEdit, onDelete }) {
  return (
    <div
      className="d-flex align-items-center justify-content-start"
      style={{ gap: 8 }}
    >
      <button
        type="button"
        onClick={onEdit}
        style={{
          background: "rgba(249,115,22,0.1)",
          border: "1px solid rgba(249,115,22,0.3)",
          borderRadius: 6,
          padding: "4px 10px",
          color: "#f97316",
          cursor: "pointer",
        }}
        title="Editar"
      >
        <i className="fa-solid fa-square-pen" />
      </button>
      <button
        type="button"
        onClick={onDelete}
        style={{
          background: "rgba(239,68,68,0.1)",
          border: "1px solid rgba(239,68,68,0.25)",
          borderRadius: 6,
          padding: "4px 10px",
          color: "#f87171",
          cursor: "pointer",
        }}
        title="Eliminar"
      >
        <i className="fa-solid fa-trash" />
      </button>
    </div>
  );
}

function TableShell({
  columns,
  children,
  page,
  totalPages,
  onPrev,
  onNext,
  total,
}) {
  return (
    <>

      <div
        className={`${styles["tab-pane"]} active ${styles["table-responsive"]}`}
      >
        <table>
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
      <div className={styles["table-footer"]}>
        <p style={{color:"var(--text-secondary)", fontSize:"0.9rem"}}>
          <>
            <span>{total}</span> resultado(s) · Página <span>{page}</span> de{" "}
            <span>{Math.max(1, totalPages)}</span>
          </>
        </p>
        <div className={`${styles["pagination-buttons"]} d-flex gap-2`}>
          <button
            className={`btn btn-sm ${styles["btn-prev"]} d-flex gap-2 align-items-center`}
            disabled={page <= 1}
            onClick={onPrev}
          >
            <i className="fa-solid fa-chevron-left" />
            Anterior
          </button>
          <button
            className={`btn btn-sm ${styles["btn-next"]} d-flex gap-2 align-items-center`}
            disabled={page >= totalPages}
            onClick={onNext}
          >
            Siguiente
            <i className="fa-solid fa-chevron-right" />
          </button>
        </div>
      </div>
    </>
  );
}

// ── useTableData: shared fetch + search + sort logic ─────────────────────────
function useTableData(endpoint, search, sortField) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(0);

  const reload = useCallback(() => setRefresh((r) => r + 1), []);

  useEffect(() => {
    setPage(1);
  }, [search, sortField]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    const params = new URLSearchParams({ page, page_size: 8 });
    if (search) params.set("search", search);
    if (sortField) params.set("ordering", sortField);
    apiFetch(`${endpoint}?${params}`)
      .then((r) => r.json())
      .then((d) => {
        if (!cancelled) {
          setData(d.results ?? d);
          setTotal(d.count ?? d.results?.length ?? d.length);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [endpoint, page, search, sortField, refresh]);

  const totalPages = Math.ceil(total / 8);
  return { data, total, page, totalPages, loading, reload, setPage };
}

// ── Owners Table ──────────────────────────────────────────────────────────────
function OwnersTable({ search, sortField }) {
  const { data, total, page, totalPages, loading, reload, setPage } =
    useTableData(
      "/api/residents/emailPropietarioPrincipal/",
      search,
      sortField,
    );

  const [editRecord, setEditRecord] = useState(null);
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [deleting, setDeleting] = useState(false);

  const owners = data.filter((d) => d.principal === true);

  async function handleDelete() {
    setDeleting(true);
    try {
      // Delete the propietario (cascades email)
      await apiFetch(
        `/api/residents/propietario/${deleteRecord.propietario?.id}/`,
        { method: "DELETE" },
      );
      setDeleteRecord(null);
      reload();
    } catch (e) {
      showToast("Error al eliminar: " + e.message, false);
    } finally {
      setDeleting(false);
    }
  }

  return (
    <>
      <TableShell
        columns={["N.Filial", "Nombre", "Email", "Teléfono", "Acciones"]}
        page={page}
        totalPages={totalPages}
        total={total}
        onPrev={() => setPage((p) => p - 1)}
        onNext={() => setPage((p) => p + 1)}
      >
        {loading ? (
          <tr>
            <td
              colSpan={5}
              style={{ textAlign: "center", padding: 24, color: "var(--text-secondary)" }}
            >
              <i
                className="fa-solid fa-circle-notch fa-spin"
                style={{ marginRight: 6, color: "#f97316" }}
              />
              Cargando…
            </td>
          </tr>
        ) : (
          owners.map((o) => (
            <tr key={o.id}>
              <td style={{ fontWeight: 600 }}>{o.filial || "—"}</td>
              <td>
                {o.propietario?.persona?.nombre_completo
                  || `${o.propietario?.persona?.nombre || ""} ${o.propietario?.persona?.apellidos || ""}`.trim()
                  || "—"}
              </td>
              <td>{o.email}</td>
              <td>
                {o.propietario?.telefono_cel
                  || o.propietario?.telefono_casa
                  || o.propietario?.telefono_trabajo
                  || o.propietario?.telefono
                  || <span style={{ color: "#4b5563" }}>—</span>}
              </td>
              <td>
                <ActionButtons
                  onEdit={() => setEditRecord(o)}
                  onDelete={() => setDeleteRecord(o)}
                />
              </td>
            </tr>
          ))
        )}
      </TableShell>

      {editRecord && (
        <EditOwnerModal
          owner={editRecord}
          onClose={() => setEditRecord(null)}
          onSaved={() => {
            setEditRecord(null);
            reload();
          }}
        />
      )}
      <ConfirmModal
        open={!!deleteRecord}
        loading={deleting}
        name={
          deleteRecord
            ? `${deleteRecord.propietario?.persona?.nombre} ${deleteRecord.propietario?.persona?.apellidos}`
            : ""
        }
        onConfirm={handleDelete}
        onCancel={() => setDeleteRecord(null)}
      />
    </>
  );
}

// ── CoOwners Table ────────────────────────────────────────────────────────────
function CoOwnersTable({ search, sortField }) {
  const { data, total, page, totalPages, loading, reload, setPage } =
    useTableData("/api/residents/copropietario/", search, sortField);

  const [editRecord, setEditRecord] = useState(null);
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [deleting, setDeleting] = useState(false);

  async function handleDelete() {
    setDeleting(true);
    try {
      await apiFetch(`/api/residents/copropietario/${deleteRecord.id}/`, {
        method: "DELETE",
      });
      setDeleteRecord(null);
      reload();
    } catch (e) {
      showToast("Error al eliminar: " + e.message, false);
    } finally {
      setDeleting(false);
    }
  }

  return (
    <>
      <TableShell
        columns={["N.Filial", "Nombre", "Teléfono", "Placa", "Acciones"]}
        page={page}
        totalPages={totalPages}
        total={total}
        onPrev={() => setPage((p) => p - 1)}
        onNext={() => setPage((p) => p + 1)}
      >
        {loading ? (
          <tr>
            <td
              colSpan={5}
              style={{ textAlign: "center", padding: 24, color: "var(--text-secondary)" }}
            >
              <i
                className="fa-solid fa-circle-notch fa-spin"
                style={{ marginRight: 6, color: "#f97316" }}
              />
              Cargando…
            </td>
          </tr>
        ) : (
          data.map((co) => (
            <tr key={co.id}>
              <td style={{ fontWeight: 600 }}>{co.filial_data?.idFilial || "—"}</td>
              <td>
                {co.persona?.nombre} {co.persona?.apellidos}
              </td>
              <td>
                {co.telefono || <span style={{ color: "#4b5563" }}>—</span>}
              </td>
              <td>
                {co.placa_vehiculo || (
                  <span style={{ color: "#4b5563" }}>—</span>
                )}
              </td>
              <td>
                <ActionButtons
                  onEdit={() => setEditRecord(co)}
                  onDelete={() => setDeleteRecord(co)}
                />
              </td>
            </tr>
          ))
        )}
      </TableShell>
      {editRecord && (
        <EditCoOwnerModal
          record={editRecord}
          onClose={() => setEditRecord(null)}
          onSaved={() => {
            setEditRecord(null);
            reload();
          }}
        />
      )}
      <ConfirmModal
        open={!!deleteRecord}
        loading={deleting}
        name={
          deleteRecord
            ? `${deleteRecord.persona?.nombre} ${deleteRecord.persona?.apellidos}`
            : ""
        }
        onConfirm={handleDelete}
        onCancel={() => setDeleteRecord(null)}
      />
    </>
  );
}

// ── Authorized Table ──────────────────────────────────────────────────────────
function AuthorizedTable({ search, sortField }) {
  const { data, total, page, totalPages, loading, reload, setPage } =
    useTableData("/api/residents/autorizado/", search, sortField);

  const [editRecord, setEditRecord] = useState(null);
  const [deleteRecord, setDeleteRecord] = useState(null);
  const [deleting, setDeleting] = useState(false);

  async function handleDelete() {
    setDeleting(true);
    try {
      await apiFetch(`/api/residents/autorizado/${deleteRecord.id}/`, {
        method: "DELETE",
      });
      setDeleteRecord(null);
      reload();
    } catch (e) {
      showToast("Error al eliminar: " + e.message, false);
    } finally {
      setDeleting(false);
    }
  }

  return (
    <>
      <TableShell
        columns={["N.Filial", "Nombre", "Relación", "Placa", "Acciones"]}
        page={page}
        totalPages={totalPages}
        total={total}
        onPrev={() => setPage((p) => p - 1)}
        onNext={() => setPage((p) => p + 1)}
      >
        {loading ? (
          <tr>
            <td
              colSpan={5}
              style={{ textAlign: "center", padding: 24, color: "var(--text-secondary)" }}
            >
              <i
                className="fa-solid fa-circle-notch fa-spin"
                style={{ marginRight: 6, color: "#f97316" }}
              />
              Cargando…
            </td>
          </tr>
        ) : (
          data.map((auth) => (
            <tr key={auth.id}>
              <td style={{ fontWeight: 600 }}>{auth.filial_data?.idFilial || "—"}</td>
              <td>
                {auth.persona?.nombre} {auth.persona?.apellidos}
              </td>
              <td>{auth.tipo}</td>
              <td>
                {auth.placa_vehiculo || (
                  <span style={{ color: "#4b5563" }}>—</span>
                )}
              </td>
              <td>
                <ActionButtons
                  onEdit={() => setEditRecord(auth)}
                  onDelete={() => setDeleteRecord(auth)}
                />
              </td>
            </tr>
          ))
        )}
      </TableShell>
      {editRecord && (
        <EditAuthModal
          record={editRecord}
          onClose={() => setEditRecord(null)}
          onSaved={() => {
            setEditRecord(null);
            reload();
          }}
        />
      )}
      <ConfirmModal
        open={!!deleteRecord}
        loading={deleting}
        name={
          deleteRecord
            ? `${deleteRecord.persona?.nombre} ${deleteRecord.persona?.apellidos}`
            : ""
        }
        onConfirm={handleDelete}
        onCancel={() => setDeleteRecord(null)}
      />
    </>
  );
}

// ── Filiales Table ────────────────────────────────────────────────────────────
function FilialesTable({ search, sortField }) {
  const { data, total, page, totalPages, loading, reload, setPage } =
    useTableData("/api/residents/filial/", search, sortField);

  const [editRecord,    setEditRecord]    = useState(null);
  const [deleteRecord,  setDeleteRecord]  = useState(null);
  const [deleting,      setDeleting]      = useState(false);
  // Two-step deletion: first fetch warning, then confirm
  const [deleteWarning, setDeleteWarning] = useState(null); // { advertencia, cuentas_a_eliminar }

  async function handleDeleteClick(f) {
    // Always show the warning modal first — never delete immediately
    setDeleteRecord(f);
    setDeleteWarning({
      advertencia:
        `¿Seguro que querés eliminar la filial ${f.idFilial}? ` +
        `Se eliminarán permanentemente sus cuentas en el catálogo (CxC y Adelantado), ` +
        `todas sus facturas, recibos y asientos de diario asociados. ` +
        `Esta acción NO se puede deshacer.`,
      cuentas_a_eliminar: [],
      requiere_confirmacion: true,
    });
  }

  async function handleDeleteConfirm() {
    setDeleting(true);
    console.log("[FILIAL DELETE] Sending DELETE to:", `/api/residents/filial/${deleteRecord.id}/?confirmar=1`);
    try {
      const res = await apiFetch(
        `/api/residents/filial/${deleteRecord.id}/?confirmar=1`,
        { method: "DELETE" }
      );
      console.log("[FILIAL DELETE] Response status:", res.status);
      if (res.status === 204) {
        // éxito
        setDeleteRecord(null);
        setDeleteWarning(null);
        reload();
        return;
      }
      // Intentar leer el cuerpo de error
      const body = await res.json().catch(() => ({}));
      const msg  = body.detail || JSON.stringify(body) || `Error HTTP ${res.status}`;
      showToast("Error al eliminar filial: " + msg, false);
    } catch (e) {
      showToast("Error al eliminar: " + e.message, false);
    } finally {
      setDeleting(false);
    }
  }

  return (
    <>
      <TableShell
        columns={["N.Filial", "N.Plano", "N.Folio", "Tipo", "Acciones"]}
        page={page}
        totalPages={totalPages}
        total={total}
        onPrev={() => setPage((p) => p - 1)}
        onNext={() => setPage((p) => p + 1)}
      >
        {loading ? (
          <tr>
            <td
              colSpan={5}
              style={{ textAlign: "center", padding: 24, color: "var(--text-secondary)" }}
            >
              <i
                className="fa-solid fa-circle-notch fa-spin"
                style={{ marginRight: 6, color: "#f97316" }}
              />
              Cargando…
            </td>
          </tr>
        ) : (
          data.map((f) => (
            <tr key={f.id}>
              <td style={{ fontWeight: 600 }}>{f.idFilial}</td>
              <td>{f.numPlano}</td>
              <td>{f.numFolio}</td>
              <td>{f.tipo_propiedad}</td>
              <td>
                <ActionButtons
                  onEdit={() => setEditRecord(f)}
                  onDelete={() => handleDeleteClick(f)}
                />
              </td>
            </tr>
          ))
        )}
      </TableShell>
      {editRecord && (
        <EditFilialModal
          filial={editRecord}
          onClose={() => setEditRecord(null)}
          onSaved={() => {
            setEditRecord(null);
            reload();
          }}
        />
      )}
      {deleteRecord && deleteWarning && (
        <div style={{position:"fixed",inset:0,zIndex:1000,background:"rgba(0,0,0,0.75)",
          backdropFilter:"blur(3px)",display:"flex",alignItems:"center",justifyContent:"center"}}
          onClick={()=>{setDeleteRecord(null);setDeleteWarning(null);}}>
          <div style={{background:"var(--bg-card)",border:"1px solid var(--border-card)",borderRadius:10,
            width:"min(480px,94vw)",padding:24,maxHeight:"90vh",overflow:"auto"}}
            onClick={e=>e.stopPropagation()}>
            <div style={{textAlign:"center",marginBottom:16}}>
              <div style={{fontSize:"2.5rem",marginBottom:8}}>⚠️</div>
              <h3 style={{color:"#f1f5f9",margin:0}}>Eliminar Filial {deleteRecord.idFilial}</h3>
              <p style={{color:"#f87171",marginTop:8,fontSize:"0.87rem",lineHeight:1.6}}>
                {deleteWarning.advertencia}
              </p>
            </div>
            {deleteWarning.cuentas_a_eliminar?.length > 0 && (
              <div style={{background:"rgba(55,65,81,0.3)",borderRadius:6,padding:"10px 14px",
                marginBottom:16,fontSize:"0.8rem"}}>
                <p style={{color:"var(--text-secondary)",margin:"0 0 6px",fontWeight:600,
                  textTransform:"uppercase",fontSize:"0.7rem"}}>
                  Cuentas contables a eliminar:
                </p>
                {deleteWarning.cuentas_a_eliminar.map((c,i)=>(
                  <div key={i} style={{color:"#e5ecf5",fontFamily:"monospace",marginBottom:2}}>
                    {c.codigo} — {c.nombre}
                  </div>
                ))}
              </div>
            )}
            <div style={{display:"flex",gap:8,justifyContent:"center"}}>
              <button type="button"
                onClick={()=>{setDeleteRecord(null);setDeleteWarning(null);}}
                style={{padding:"9px 20px",background:"rgba(55,65,81,0.4)",
                  border:"1px solid var(--border-card)",borderRadius:7,color:"var(--text-secondary)",cursor:"pointer"}}>
                Cancelar
              </button>
              <button type="button" onClick={handleDeleteConfirm} disabled={deleting}
                style={{padding:"9px 20px",background:"rgba(239,68,68,0.15)",
                  border:"1px solid rgba(239,68,68,0.4)",borderRadius:7,color:"#f87171",
                  cursor:"pointer",fontWeight:700,opacity:deleting?0.6:1}}>
                {deleting?"Eliminando…":"Sí, eliminar todo"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// MAIN PAGE
// ═══════════════════════════════════════════════════════════════════════════════
const TABS = ["Propietarios", "Copropietarios", "Autorizados", "Filiales"];

const SORT_OPTIONS_PROPIETARIO = [
  { label: "N.Filial A→Z", value: "propietario__filial__idFilial" },
  { label: "N.Filial Z→A", value: "-propietario__filial__idFilial" },
  { label: "Apellidos A→Z", value: "propietario__persona__apellidos" },
  { label: "Apellidos Z→A", value: "-propietario__persona__apellidos" },
];
const SORT_OPTIONS_PERSONA = [
  { label: "N.Filial A→Z", value: "filial__idFilial" },
  { label: "N.Filial Z→A", value: "-filial__idFilial" },
  { label: "Apellidos A→Z", value: "persona__apellidos" },
  { label: "Apellidos Z→A", value: "-persona__apellidos" },
];
const SORT_FILIAL_OPTIONS = [
  { label: "ID Filial A→Z", value: "idFilial" },
  { label: "ID Filial Z→A", value: "-idFilial" },
];

export default function ListResidents() {
  const [activeTab, setActiveTab] = useState(0);
  const [search, setSearch] = useState("");
  const [sortField, setSortField] = useState("");
  const [showSort, setShowSort] = useState(false);
  const searchRef = useRef();

  const sortOptions =
    activeTab === 3 ? SORT_FILIAL_OPTIONS :
    activeTab === 0 ? SORT_OPTIONS_PROPIETARIO :
    SORT_OPTIONS_PERSONA;
  const currentSortLabel =
    sortOptions.find((s) => s.value === sortField)?.label || "Ordenar";

  function handleTabChange(idx) {
    setActiveTab(idx);
    setSearch("");
    setSortField("");
    setShowSort(false);
  }

  return (
    <>
      <span className={styles.inactive}>
        <Link to="/">
          <span className={styles.inactive}>Inicio </span>
        </Link>
        / <span className={styles.active}>Residentes</span>
      </span>

      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
        <div>
          <h2 className="mt-2 me-2 p-0 title">Gestión de Residentes</h2>
          <p className="mb-0" style={{color:"var(--text-secondary)"}}>Administra los residentes de tu condominio</p>
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <Link
            to="/residentes/agregar"
            className={`btn ${styles["btn-add-resident"]} d-flex gap-2 align-items-center`}
          >
            <i className="fa-solid fa-plus" />
            Agregar Residente
          </Link>
          <ImportExportBar
            plantillaUrl="/api/residents/filial/plantilla-excel/"
            plantillaFilename="plantilla_filiales.xlsx"
            importarUrl="/api/residents/filial/importar-excel/"
            onResult={(res) => {
              if (res) showToast(res.msg, res.ok);
            }}
          />
        </div>
      </div>

      <div className={styles["table-container"]}>
        {/* Search + sort bar */}
        <div
          className={`${styles["table-header"]} d-flex align-items-center justify-content-between`}
        >
          <div
            className={`${styles["input-header"]} d-flex align-items-center gap-2`}
          >
            <i className="fa-solid fa-magnifying-glass" />
            <input
              ref={searchRef}
              type="text"
              placeholder={
                activeTab === 3
                  ? "Buscar por N. Filial…"
                  : "Buscar por nombre o filial…"
              }
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search && (
              <button
                onClick={() => setSearch("")}
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--text-muted)",
                  cursor: "pointer",
                }}
              >
                ✕
              </button>
            )}
          </div>

          <div
            className={`${styles["actions-buttons-header"]} d-flex gap-2`}
            style={{ position: "relative" }}
          >
            <button
              className={`btn ${styles["btn-sort"]} d-flex gap-2 align-items-center`}
              onClick={() => setShowSort((v) => !v)}
            >
              <i className="fa-solid fa-sort" />
              {currentSortLabel}
            </button>
            {showSort && (
              <div
                style={{
                  position: "absolute",
                  top: "110%",
                  right: 0,
                  zIndex: 200,
                  background: "var(--bg-card)",
                  border: "1px solid var(--border-card)",
                  borderRadius: 8,
                  overflow: "hidden",
                  minWidth: 180,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.4)",
                }}
              >
                <div
                  style={{
                    padding: "6px 12px",
                    fontSize: "0.72rem",
                    color: "var(--text-muted)",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    borderBottom: "1px solid var(--border-card)",
                  }}
                >
                  Ordenar por
                </div>
                {[{ label: "Sin orden", value: "" }, ...sortOptions].map(
                  (opt) => (
                    <button
                      key={opt.value}
                      type="button"
                      onClick={() => {
                        setSortField(opt.value);
                        setShowSort(false);
                      }}
                      style={{
                        display: "block",
                        width: "100%",
                        textAlign: "left",
                        padding: "9px 14px",
                        background:
                          sortField === opt.value
                            ? "rgba(249,115,22,0.1)"
                            : "transparent",
                        border: "none",
                        color: sortField === opt.value ? "#f97316" : "#d1d5db",
                        fontSize: "0.84rem",
                        cursor: "pointer",
                      }}
                    >
                      {sortField === opt.value && (
                        <i
                          className="fa-solid fa-check"
                          style={{ marginRight: 6, fontSize: "0.72rem" }}
                        />
                      )}
                      {opt.label}
                    </button>
                  ),
                )}
              </div>
            )}
          </div>
        </div>

        {/* Tabs */}
        <div className={styles["tabs-wrapper"]}>
          <div className={styles["tabs-nav"]}>
            {TABS.map((tab, idx) => (
              <button
                key={idx}
                className={`${styles["tab-btn"]} ${activeTab === idx ? styles.active : ""}`}
                onClick={() => handleTabChange(idx)}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="tabs-body">
            {activeTab === 0 && (
              <OwnersTable search={search} sortField={sortField} />
            )}
            {activeTab === 1 && (
              <CoOwnersTable search={search} sortField={sortField} />
            )}
            {activeTab === 2 && (
              <AuthorizedTable search={search} sortField={sortField} />
            )}
            {activeTab === 3 && (
              <FilialesTable search={search} sortField={sortField} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
